import { useSortable } from "@dnd-kit/sortable";
import { GripVertical } from "lucide-react";
import { Button } from "@/components/ui/button";

export const RowDragHandleCell = ({
  rowId,
  color,
  isDisabled = false
}: {
  rowId: string;
  /** CSS color for the handle icon. */
  color?: string;
  isDisabled?: boolean;
}) => {
  const { attributes, listeners } = useSortable({
    id: rowId,
    data: {
      id: rowId
    }
  });
  return (
    <Button
      variant="ghost"
      size="icon-sm"
      disabled={isDisabled}
      style={color ? { color } : undefined}
      aria-label="shuffle"
      {...listeners}
      {...attributes}
    >
      <GripVertical />
    </Button>
  );
};
